/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Payment_Status_VoidInputs */

const fr_payment_status_void = /** @type {(inputs: Payment_Status_VoidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annulé`)
};

/**

* @param {Payment_Status_VoidInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const payment_status_void = /** @type {((inputs?: Payment_Status_VoidInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payment_Status_VoidInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_payment_status_void(inputs)
});